var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgExcel(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 16,
    viewBox: "0 0 15 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_590:15999)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9.375 11.6836H8.40234L7.46484 10.1602L6.52734 11.6836H5.625L6.96094 9.60937L5.70703 7.66406H6.64453L7.51172 9.10547L8.35547 7.66406H9.26953L8.00391 9.65625L9.375 11.6836Z",
    fill: "#007732"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.1875 15.1992H2.8125C2.16797 15.1992 1.64062 14.6719 1.64062 14.0273V1.83984C1.64062 1.19531 2.16797 0.667969 2.8125 0.667969H7.58203C7.89844 0.667969 8.19141 0.785156 8.41406 1.00781L13.0195 5.61328C13.2422 5.83594 13.3594 6.12891 13.3594 6.44531V14.0273C13.3594 14.6719 12.832 15.1992 12.1875 15.1992ZM2.8125 1.13672C2.42578 1.13672 2.10938 1.45312 2.10938 1.83984V14.0273C2.10938 14.4141 2.42578 14.7305 2.8125 14.7305H12.1875C12.5742 14.7305 12.8906 14.4141 12.8906 14.0273V6.44531C12.8906 6.25781 12.8203 6.08203 12.6797 5.95312L8.07422 1.34766C7.94531 1.20703 7.76953 1.13672 7.58203 1.13672H2.8125Z",
    fill: "#007732"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_590:15999"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 15,
    height: 15,
    fill: "white",
    transform: "translate(0 0.433594)"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgExcel);
export default __webpack_public_path__ + "static/media/excel.dd9cb8c3.svg";
export { ForwardRef as ReactComponent };